import './INVC.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class INVC extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initCactEvents();
	}

	initCactEvents () {
		this.initCactFormValidation();
		this.initCactToggle();
	}

	async initCactFormValidation () {
		const cactForm = document.getElementById('js-invoice-cact-form');

		if (!cactForm) {
			return;
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		new HTMLFormValidator({
			fieldContainer: '.g-invoice__cact-item',
			formElement: cactForm
		});
	}

	initCactToggle () {
		const toggleElem = document.getElementById('js-invoice-cact-toggle');
		const emailRow = document.getElementById('js-invoice-cact-email');
		const emailInput = document.getElementById('l-Customer_LoginEmail');

		if (!toggleElem || !emailRow || !emailInput) {
			return;
		}

		toggleElem.addEventListener('change', () => this.toggleCact(toggleElem, emailRow, emailInput));
	}

	toggleCact (checkbox, row, input) {
		const email = checkbox.getAttribute('data-email');

		if (checkbox.checked) {
			row.classList.add('u-hidden');
			input.value = email;
		} else {
			row.classList.remove('u-hidden');

			if (input.value === email) {
				input.value = '';
			}
		}
	}
}
